import _cloneDeep from "lodash/cloneDeep";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  style: {
    "width": "60%"
  }
};
const _hoisted_2 = {
  style: {
    "margin-top": "10px"
  }
};
import PreviewDialog from './Preview.vue';
import GenToPathDialog from './GenToPath.vue';
import GenMenuAuthDialog from './GenMenuAuth.vue';
import { download, downloadExportTemplate } from '../../api/code-gen';
import { MagicStick, Download } from '@element-plus/icons-vue';

import { ref, watch } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'CodeGenerator',
  props: {
    business: {
      type: Object,
      default: () => ({})
    }
  },
  setup(__props) {
    const props = __props;
    const dialogPreview = ref();
    const dialogGenToPath = ref();
    const dialogGenMenuAuth = ref();
    const formInstance = ref();
    const form = ref({
      rules: {
        basePackage: [{
          required: true,
          message: '请输入基础包名',
          trigger: 'blur'
        }],
        moduleName: [{
          required: true,
          message: '请输入模块名',
          trigger: 'blur'
        }],
        businessName: [{
          required: true,
          message: '请输入业务名',
          trigger: 'blur'
        }],
        businessComment: [{
          required: true,
          message: '请输入业务描述',
          trigger: 'blur'
        }],
        businessAuthor: [{
          required: true,
          message: '请输入业务作者',
          trigger: 'blur'
        }]
      }
    });
    const action = ref({
      downloading: false,
      downloadingExportTemplate: false
    });
    const gen = ref({
      tableName: '',
      tableComment: '',
      basePackage: '',
      moduleName: '',
      businessName: '',
      businessComment: '',
      businessAuthor: '',
      frontendPath: '',
      backendPath: '',
      abilities: {
        create: {
          enable: true
        },
        delete: {
          enable: true
        },
        update: {
          enable: true
        },
        query: {
          enable: true
        },
        import: {
          enable: true
        },
        export: {
          enable: true
        },
        authority: {
          enable: true
        }
      }
    });
    watch(() => props.business, val => {
      val.abilities = {
        create: {
          enable: true
        },
        delete: {
          enable: true
        },
        update: {
          enable: true
        },
        query: {
          enable: true
        },
        import: {
          enable: true
        },
        export: {
          enable: true
        },
        authority: {
          enable: true
        }
      };
      gen.value = val;
    });
    function handlePreview() {
      formInstance.value?.validate(valid => {
        if (valid) {
          dialogPreview.value?.show(getBusiness());
        }
      });
    }
    function handleGenToPath() {
      formInstance.value?.validate(valid => {
        if (valid) {
          dialogGenToPath.value?.show(getBusiness());
        }
      });
    }
    function handleGenMenuAuth() {
      formInstance.value?.validate(valid => {
        if (valid) {
          dialogGenMenuAuth.value?.show(getBusiness());
        }
      });
    }
    function handleDownload() {
      if (action.value.downloading) {
        return;
      }
      formInstance.value?.validate(valid => {
        if (valid) {
          action.value.downloading = true;
          download(getBusiness()).finally(() => {
            action.value.downloading = false;
          });
        }
      });
    }
    function handleDownloadExportTemplate() {
      if (action.value.downloadingExportTemplate) {
        return;
      }
      formInstance.value?.validate(valid => {
        if (valid) {
          action.value.downloadingExportTemplate = true;
          downloadExportTemplate(getBusiness()).finally(() => {
            action.value.downloadingExportTemplate = false;
          });
        }
      });
    }
    function getBusiness() {
      const business = _cloneDeep(gen.value);
      if (business.abilities) {
        for (const k of Object.keys(business.abilities)) {
          if (business.abilities[k].enable) {
            business.abilities[k].name = k;
          } else {
            // 删除未启用的功能
            delete business.abilities[k];
          }
        }
      }
      return business;
    }
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_checkbox = _resolveComponent("el-checkbox");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_form, {
        ref_key: "formInstance",
        ref: formInstance,
        model: _unref(gen),
        "label-width": "100px",
        rules: _unref(form).rules
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 12
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "表名称"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: _unref(gen).tableName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(gen).tableName = $event),
                readonly: ""
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 12
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "表描述"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: _unref(gen).tableComment,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(gen).tableComment = $event),
                readonly: ""
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 12
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "基础包名",
              prop: "basePackage"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: _unref(gen).basePackage,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(gen).basePackage = $event),
                placeholder: "基础包名，如：com.example.modules"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 12
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "所属模块",
              prop: "moduleName"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: _unref(gen).moduleName,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(gen).moduleName = $event),
                placeholder: "所属模块，如：basic"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 12
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "功能名称",
              prop: "businessName"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: _unref(gen).businessName,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _unref(gen).businessName = $event),
                placeholder: "功能名称，如：User"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 12
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "功能描述",
              prop: "businessComment"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: _unref(gen).businessComment,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _unref(gen).businessComment = $event),
                placeholder: "功能描述，如：用户管理"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 12
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "功能作者",
              prop: "businessAuthor"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: _unref(gen).businessAuthor,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _unref(gen).businessAuthor = $event),
                placeholder: "功能作者，如：张三"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _withDirectives(_createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 12
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "前端路径"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                placeholder: "前端工程路径，如：F:\\Projects\\SunDrawVue"
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 12
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "后端路径"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                placeholder: "后端工程路径，如：F:\\Projects\\SunDrawBoot"
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 512), [[_vShow, false]]), _createVNode(_component_el_form_item, {
          label: "基本功能"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_checkbox, {
            modelValue: _unref(gen).abilities.query.enable,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _unref(gen).abilities.query.enable = $event),
            disabled: ""
          }, {
            default: _withCtx(() => _cache[14] || (_cache[14] = [_createTextVNode("查询")])),
            _: 1
          }, 8, ["modelValue"]), _createVNode(_component_el_checkbox, {
            modelValue: _unref(gen).abilities.create.enable,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => _unref(gen).abilities.create.enable = $event)
          }, {
            default: _withCtx(() => _cache[15] || (_cache[15] = [_createTextVNode("新增")])),
            _: 1
          }, 8, ["modelValue"]), _createVNode(_component_el_checkbox, {
            modelValue: _unref(gen).abilities.update.enable,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => _unref(gen).abilities.update.enable = $event)
          }, {
            default: _withCtx(() => _cache[16] || (_cache[16] = [_createTextVNode("修改")])),
            _: 1
          }, 8, ["modelValue"]), _createVNode(_component_el_checkbox, {
            modelValue: _unref(gen).abilities.delete.enable,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => _unref(gen).abilities.delete.enable = $event)
          }, {
            default: _withCtx(() => _cache[17] || (_cache[17] = [_createTextVNode("删除")])),
            _: 1
          }, 8, ["modelValue"]), _createVNode(_component_el_checkbox, {
            modelValue: _unref(gen).abilities.import.enable,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => _unref(gen).abilities.import.enable = $event)
          }, {
            default: _withCtx(() => _cache[18] || (_cache[18] = [_createTextVNode("导入")])),
            _: 1
          }, 8, ["modelValue"]), _createVNode(_component_el_checkbox, {
            modelValue: _unref(gen).abilities.export.enable,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => _unref(gen).abilities.export.enable = $event)
          }, {
            default: _withCtx(() => _cache[19] || (_cache[19] = [_createTextVNode("导出")])),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "其他功能"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_checkbox, {
            modelValue: _unref(gen).abilities.authority.enable,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => _unref(gen).abilities.authority.enable = $event)
          }, {
            default: _withCtx(() => _cache[20] || (_cache[20] = [_createTextVNode("权限校验")])),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["model", "rules"])]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
        type: "success",
        icon: _unref(MagicStick),
        onClick: handlePreview
      }, {
        default: _withCtx(() => _cache[21] || (_cache[21] = [_createTextVNode("预览")])),
        _: 1
      }, 8, ["icon"]), _createVNode(_component_el_button, {
        type: "primary",
        icon: _unref(Download),
        loading: _unref(action).downloading,
        onClick: handleDownload
      }, {
        default: _withCtx(() => _cache[22] || (_cache[22] = [_createTextVNode("下载代码 ")])),
        _: 1
      }, 8, ["icon", "loading"]), _createVNode(_component_el_button, {
        type: "primary",
        icon: _unref(Download),
        onClick: handleGenToPath
      }, {
        default: _withCtx(() => _cache[23] || (_cache[23] = [_createTextVNode("生成到指定路径")])),
        _: 1
      }, 8, ["icon"]), _createVNode(_component_el_button, {
        type: "primary",
        icon: _unref(Download),
        loading: _unref(action).downloadingExportTemplate,
        onClick: handleDownloadExportTemplate
      }, {
        default: _withCtx(() => _cache[24] || (_cache[24] = [_createTextVNode("下载导入/导出模板")])),
        _: 1
      }, 8, ["icon", "loading"]), _createVNode(_component_el_button, {
        type: "primary",
        icon: _unref(Download),
        onClick: handleGenMenuAuth
      }, {
        default: _withCtx(() => _cache[25] || (_cache[25] = [_createTextVNode("生成菜单/权限")])),
        _: 1
      }, 8, ["icon"])]), _createVNode(PreviewDialog, {
        ref_key: "dialogPreview",
        ref: dialogPreview
      }, null, 512), _createVNode(GenToPathDialog, {
        ref_key: "dialogGenToPath",
        ref: dialogGenToPath
      }, null, 512), _createVNode(GenMenuAuthDialog, {
        ref_key: "dialogGenMenuAuth",
        ref: dialogGenMenuAuth
      }, null, 512)]);
    };
  }
});